import { render, staticRenderFns } from "./materiaAllocate.vue?vue&type=template&id=59483aaa"
import script from "./materiaAllocate.vue?vue&type=script&lang=js"
export * from "./materiaAllocate.vue?vue&type=script&lang=js"
import style0 from "./materiaAllocate.vue?vue&type=style&index=0&id=59483aaa&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports